import React from 'react'
import Marquee from 'react-fast-marquee'
import { images } from '../../constants'

const Gallery = () => {
  return (
    <div className="gallery-container">
      <div className="container-xxl p-4">
        <h1 className="text-center text-light mt-5">Gallery</h1>
        <div
          className="mb-5 mt-5 row text-center"
          id="gallery"
        >
          <img
            src={images.gallery01}
            class="img-fluid col-6 col-md-3 mb-4"
            alt="gallery"
          />
          <img
            src={images.gallery02}
            class="img-fluid col-6 col-md-3 mb-4"
            alt="gallery"
          />
          <img
            src={images.gallery03}
            class="img-fluid col-6 col-md-3 mb-4"
            alt="gallery"
          />
          <img
            src={images.gallery04}
            class="img-fluid col-6 col-md-3 mb-4"
            alt="gallery"
          />
          <img
            src={images.gallery05}
            class="img-fluid col-6 col-md-3 mb-4"
            alt="gallery"
          />
          <img
            src={images.gallery06}
            class="img-fluid col-6 col-md-3 mb-4"
            alt="gallery"
          />
          <img
            src={images.gallery07}
            class="img-fluid col-6 col-md-3 mb-4"
            alt="gallery"
          />
          <img
            src={images.gallery08}
            class="img-fluid col-6 col-md-3 mb-4"
            alt="gallery"
          />
        </div>
      </div>
    </div>
  )
}

export default Gallery
